import { Hub } from "aws-amplify/utils";
import { getCurrentUser as amplifyGetCurrentUser } from "aws-amplify/auth";
import { useCallback, useEffect } from "react";
import store from "../appStore";
import useHashLocation from "../use-hash-location";
import { currentLocation } from "../use-hash-location";

const AuthListener = ({ ...props }) => {
  const [location, setLocation] = useHashLocation();

  const returnToPrevLocation = () => {
    setLocation(`${currentLocation().replace("/login", "").replace("/cta", "")}`);
  };

  useEffect(() => {
    const updateUser = (data) => {
      getCurrentUser();
    };

    const getCurrentUser = async () => {
      try {
        const currentUser = await amplifyGetCurrentUser();
        if (currentUser) {
          store.currentUser = currentUser;
          returnToPrevLocation();
        } else store.currentUser = import.meta.env.MODE === "electron" ? { id: "electron" } : null;
      } catch {
        store.currentUser = import.meta.env.MODE === "electron" ? { id: "electron" } : null;
      }
    };

    const hubListenerCancel = Hub.listen("auth", updateUser);

    getCurrentUser();

    return () => hubListenerCancel();
  }, []);

  return null;
};

export default AuthListener;
